import React from 'react';

const SetHeader = ({
  setInfo,
  isShared,
  viewMode,
  onViewModeChange
}) => {
  if (!setInfo) return null;

  return (
    <div className="bg-white shadow border-b border-gray-200">
      <div className="max-w-7xl mx-auto py-4 sm:py-6 px-3 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:justify-between">
          <div className="text-center sm:text-left">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{setInfo.name}</h1>
            {isShared && setInfo.sharedBy && (
              <p className="mt-1 text-sm text-gray-500">
                Shared by {setInfo.sharedBy}
              </p>
            )}
            {isShared && !setInfo.sharedBy && (
              <p className="mt-1 text-sm text-gray-500">
                Shared set
              </p>
            )}
          </div>
          <div className="flex justify-center sm:justify-end space-x-2 sm:space-x-4">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm rounded-md ${viewMode === 'grid' ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Grid
            </button>
            <button
              onClick={() => onViewModeChange('carousel')}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm rounded-md ${viewMode === 'carousel' ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Carousel
            </button>
            <button
              onClick={() => onViewModeChange('timeline')}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm rounded-md ${viewMode === 'timeline' ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Timeline
            </button>
            <button
              onClick={() => onViewModeChange('details')}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm rounded-md ${viewMode === 'details' ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Details
            </button>
          </div>
        </div>
        {setInfo.description && (
          <p className="mt-3 text-sm sm:text-base text-center sm:text-left text-gray-600">{setInfo.description}</p>
        )}
      </div>
    </div>
  );
};

export default SetHeader;
